/* 🤖 this file was generated by svg-to-ts */
export const iconStatuswallet: {
  name: 'statuswallet';
  data: string;
} = {
  name: 'statuswallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m-3.72 24.18C9.74 24.18 8 22.94 8 20.36s2.09-3.82 5.14-3.82c2.25 0 3.31.43 5.56.43.56 0 1.11-.04 1.66-.14-.45 4.18-3.94 7.35-8.08 7.35m6.58-8.73c-2.25 0-3.31-.43-5.56-.43-.56 0-1.11.04-1.66.14.45-4.18 3.94-7.35 8.08-7.35 2.54 0 4.28 1.24 4.28 3.82s-2.09 3.82-5.14 3.82"/></svg>`,
};
